// apps/web/src/features/dashai/lib/chatClient.ts
//
// Client helper for the core DashAI chat Firebase function (`dashaiChat`).
// Handles the conversational core plus any workflow type that does not have a
// dedicated standalone function. Exposes:
//   - postWithAuthRetry (re-exported from onePSfaClient)
//   - getChatUrl()
//   - streamChat(body, signal?) — SSE mode, returns the raw Response so callers
//     can iterate via getReader().read()

export { postWithAuthRetry } from './onePSfaClient';

import { postWithAuthRetry } from './onePSfaClient';

export function getChatUrl(): string | undefined {
  const explicit = import.meta.env.VITE_CHAT_URL as string | undefined;
  if (explicit) return explicit;
  const base = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
  if (base) return `${base.replace(/\/+$/, '')}/dashaiChat`;
  return undefined;
}

export async function streamChat(body: unknown, signal?: AbortSignal): Promise<Response> {
  const url = getChatUrl();
  if (!url) throw new Error('Chat function URL not configured');
  const res = await postWithAuthRetry(url, body, signal);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `streamChat failed (${res.status})`);
  }
  return res;
}
